<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <div class="divider" :style="style"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-divider #hot-reload-debug
export default {
    name: `cms-block-divider`,
    components: {CmsBlock},
    extends: CmsBlock,
    computed: {
        style() {
            return {
                height: this.block.height,
                borderRadius: this.block.borderRadius,
                backgroundColor: this.block.color,
                width: this.block.width
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
